import React from 'react';
import { useParams } from 'react-router-dom';
import CardForm from '../components/CardForm';
import { getCardById, saveCard } from '../utils/cardStorage';

const EditCard = () => {
  const { id } = useParams();
  
  // Si ID est fourni, c'est une modification, sinon c'est une nouvelle carte
  const cardData = id ? getCardById(id) : null;
  
  const handleSave = (formData) => {
    saveCard(formData);
  };
  
  return (
    <CardForm onSave={handleSave} initialData={cardData} />
  );
};

export default EditCard;
